import type { ButtonProps } from "@mantine/core";
import { IconUpload } from "@tabler/icons-react";
import type { ComponentProps } from "react";
import { IconButton } from "../../../../../../mantine/components/IconButton/IconButton";

type UploadVollmachtButtonProps = ButtonProps & ComponentProps<"button">;

function UploadVollmachtButton(props: UploadVollmachtButtonProps) {
  return (
    <IconButton icon={IconUpload} td="underline" variant="subtle" {...props}>
      Vollmacht hochladen
    </IconButton>
  );
}

export { UploadVollmachtButton };
